import { useFastProductEnablementQuery } from '@/queries/companySettings/companySettingsQueries'
import { computed } from 'vue'
import { useCurrentCompany } from './swr/useCurrentCompany'
import { useMe } from './swr/useMe'

/**
 * Any one of three sources grants a flag: the company's config arrays, a policy
 * on the user (`features.adminview`), or Fast's enabled products. The user path
 * is not a fallback — over 100k users hold `enable_scorm_support` per-policy on
 * companies whose own config omits it.
 */
export const useFeatureFlags = () => {
  const { data: currentCompany } = useCurrentCompany()
  const { data: currentUser } = useMe()
  const { data: fastProductFlags } = useFastProductEnablementQuery()

  const featureFlags = computed(() => {
    if (!currentCompany.value || !currentUser.value) {
      return
    }
    const {
      adminview_configurations,
      feature_flags,
      portal_configurations,
      supported_configurations,
    } = currentCompany.value
    return [
      ...adminview_configurations,
      ...feature_flags,
      ...portal_configurations,
      ...supported_configurations,
      ...(fastProductFlags.value ?? []),
      ...(currentUser.value.features?.adminview ?? []),
    ]
  })

  return { featureFlags }
}

export const useFeatureFlag = (flag: string) => {
  const { featureFlags } = useFeatureFlags()

  const isEnabled = computed(() => featureFlags.value?.includes(flag))

  return { isEnabled }
}
